/**
 * O número e o nome de quem conversa, como a pessoa os reconhece (spec 028).
 * Moram aqui, e não no web, porque são dois leitores: a tela da conversa e a
 * conversa em PDF que a API gera. Os dois escrevem o mesmo número do mesmo jeito.
 */

/**
 * O número como a pessoa o reconhece (spec 028): `+55 38 99988-0075` para o
 * brasileiro (com ou sem o nono dígito), `+<dígitos>` para o resto. null sem
 * dígito nenhum.
 */
export function formatWaPhone(raw: string | null | undefined): string | null {
  const d = (raw ?? '').replace(/\D/g, '');
  if (d === '') return null;
  const br = /^55([1-9]{2})(\d{8,9})$/.exec(d);
  if (!br) return `+${d}`;
  const [, ddd, local] = br as unknown as [string, string, string];
  const cut = local.length - 4;
  return `+55 ${ddd} ${local.slice(0, cut)}-${local.slice(cut)}`;
}

/** o nome é só um telefone (o marcador de "sem nome" que o servidor grava) */
const PHONE_ONLY = /^\+?\d{8,15}$/;

/**
 * O nome na tela (spec 028, FR-004): a conversa sem nome — vazio (a Blip não
 * manda o perfil) ou o próprio telefone, o marcador que o servidor grava —
 * aparece pelo telefone formatado, nunca como "?".
 */
export function chatDisplayName(chat: {
  requestorName: string;
  waContact?: string | null;
  requestorPhone?: string | null;
}): string {
  const name = chat.requestorName.trim();
  if (chatHasName(chat)) return name;
  return formatWaPhone(name || chat.waContact || chat.requestorPhone) ?? 'Sem nome';
}

/**
 * A conversa tem nome? (spec 056: o painel "Contato" abre o campo vazio quando
 * não tem.) Vazio, ou só o telefone, não é nome — a mesma regra do chatDisplayName.
 */
export function chatHasName(chat: { requestorName: string }): boolean {
  const name = chat.requestorName.trim();
  return name !== '' && !PHONE_ONLY.test(name);
}
